import countries from 'world-countries';

import { CountryListItem } from '../types';

export function getCountriesList(): CountryListItem[] {
  const countriesList: CountryListItem[] = [];

  countries.forEach((country) => {
    countriesList.push({
      label: country.name.common,
      value: country.cca2,
    });
  });

  // Sort the countries list alphabetically by the label (country name)
  countriesList.sort((a, b) => a.label.localeCompare(b.label));

  return countriesList;
}
